// Runtime UI strings for the Vue download widget. Keyed by <html lang>.
// Page copy lives in ./locales/<code>.js and is rendered at build time.
module.exports = {
    en: {
        form: {
            label: "Video URL",
            placeholder: "Paste a video URL",
            button: "DOWNLOAD",
            loading: "LOADING…",
            hint: "Example: https://www.youtube.com/watch?v=...",
            noscript: "JavaScript is disabled. Submitting this form opens the download panel in a new tab."
        },
        ui: {
            emptyError: "Please paste a video URL first.",
            invalidError: "That does not look like a valid URL.",
            protocolError: "Only http and https links are supported.",
            statusLoading: "Loading download options…",
            statusSlowBefore: "The download panel is taking longer than expected. ",
            statusOpenTab: "Open it in a new tab",
            statusSlowAfter: ".",
            iframeTitle: "Video download options",
            noteBefore: "If the download panel does not load, ",
            noteLink: "open the options in a new tab",
            noteAfter: "."
        }
    },
    es: {
        form: {
            label: "URL del vídeo",
            placeholder: "Pega la URL de un vídeo",
            button: "DESCARGAR",
            loading: "CARGANDO…",
            hint: "Ejemplo: https://www.youtube.com/watch?v=...",
            noscript: "JavaScript está desactivado. Si envías este formulario, el panel de descarga se abrirá en una pestaña nueva."
        },
        ui: {
            emptyError: "Primero pega la URL de un vídeo.",
            invalidError: "Eso no parece una URL válida.",
            protocolError: "Solo se admiten enlaces http y https.",
            statusLoading: "Cargando opciones de descarga…",
            statusSlowBefore: "El panel de descarga está tardando más de lo esperado. ",
            statusOpenTab: "Ábrelo en una pestaña nueva",
            statusSlowAfter: ".",
            iframeTitle: "Opciones de descarga del vídeo",
            noteBefore: "Si el panel de descarga no se carga, ",
            noteLink: "abre las opciones en una pestaña nueva",
            noteAfter: "."
        }
    },
    "pt-BR": {
        form: {
            label: "URL do vídeo",
            placeholder: "Cole a URL de um vídeo",
            button: "BAIXAR",
            loading: "CARREGANDO…",
            hint: "Exemplo: https://www.youtube.com/watch?v=...",
            noscript: "O JavaScript está desativado. Ao enviar este formulário, o painel de download será aberto em uma nova aba."
        },
        ui: {
            emptyError: "Cole a URL de um vídeo primeiro.",
            invalidError: "Isso não parece ser uma URL válida.",
            protocolError: "Só há suporte para links http e https.",
            statusLoading: "Carregando opções de download…",
            statusSlowBefore: "O painel de download está demorando mais que o esperado. ",
            statusOpenTab: "Abrir em uma nova aba",
            statusSlowAfter: ".",
            iframeTitle: "Opções de download do vídeo",
            noteBefore: "Se o painel de download não carregar, ",
            noteLink: "abra as opções em uma nova aba",
            noteAfter: "."
        }
    },
    fr: {
        form: {
            label: "URL de la vidéo",
            placeholder: "Collez l'URL d'une vidéo",
            button: "TÉLÉCHARGER",
            loading: "CHARGEMENT…",
            hint: "Exemple : https://www.youtube.com/watch?v=...",
            noscript: "JavaScript est désactivé. L'envoi de ce formulaire ouvrira le panneau de téléchargement dans un nouvel onglet."
        },
        ui: {
            emptyError: "Collez d'abord l'URL d'une vidéo.",
            invalidError: "Cela ne ressemble pas à une URL valide.",
            protocolError: "Seuls les liens http et https sont pris en charge.",
            statusLoading: "Chargement des options de téléchargement…",
            statusSlowBefore: "Le panneau de téléchargement met plus de temps que prévu. ",
            statusOpenTab: "Ouvrez-le dans un nouvel onglet",
            statusSlowAfter: ".",
            iframeTitle: "Options de téléchargement de la vidéo",
            noteBefore: "Si le panneau de téléchargement ne se charge pas, ",
            noteLink: "ouvrez les options dans un nouvel onglet",
            noteAfter: "."
        }
    },
    de: {
        form: {
            label: "Video-URL",
            placeholder: "Video-URL einfügen",
            button: "HERUNTERLADEN",
            loading: "WIRD GELADEN…",
            hint: "Beispiel: https://www.youtube.com/watch?v=...",
            noscript: "JavaScript ist deaktiviert. Wenn Sie dieses Formular absenden, öffnet sich das Download-Panel in einem neuen Tab."
        },
        ui: {
            emptyError: "Bitte fügen Sie zuerst eine Video-URL ein.",
            invalidError: "Das sieht nicht nach einer gültigen URL aus.",
            protocolError: "Es werden nur http- und https-Links unterstützt.",
            statusLoading: "Download-Optionen werden geladen…",
            statusSlowBefore: "Das Download-Panel dauert länger als erwartet. ",
            statusOpenTab: "In einem neuen Tab öffnen",
            statusSlowAfter: ".",
            iframeTitle: "Video-Download-Optionen",
            noteBefore: "Wenn das Download-Panel nicht lädt, ",
            noteLink: "öffnen Sie die Optionen in einem neuen Tab",
            noteAfter: "."
        }
    },
    it: {
        form: {
            label: "URL del video",
            placeholder: "Incolla l'URL di un video",
            button: "SCARICA",
            loading: "CARICAMENTO…",
            hint: "Esempio: https://www.youtube.com/watch?v=...",
            noscript: "JavaScript è disattivato. Inviando questo modulo, il pannello di download si aprirà in una nuova scheda."
        },
        ui: {
            emptyError: "Incolla prima l'URL di un video.",
            invalidError: "Non sembra un URL valido.",
            protocolError: "Sono supportati solo i link http e https.",
            statusLoading: "Caricamento delle opzioni di download…",
            statusSlowBefore: "Il pannello di download sta impiegando più tempo del previsto. ",
            statusOpenTab: "Aprilo in una nuova scheda",
            statusSlowAfter: ".",
            iframeTitle: "Opzioni di download del video",
            noteBefore: "Se il pannello di download non si carica, ",
            noteLink: "apri le opzioni in una nuova scheda",
            noteAfter: "."
        }
    },
    ru: {
        form: {
            label: "URL видео",
            placeholder: "Вставьте URL видео",
            button: "СКАЧАТЬ",
            loading: "ЗАГРУЗКА…",
            hint: "Пример: https://www.youtube.com/watch?v=...",
            noscript: "JavaScript отключён. При отправке этой формы панель загрузки откроется в новой вкладке."
        },
        ui: {
            emptyError: "Сначала вставьте URL видео.",
            invalidError: "Это не похоже на действительный URL.",
            protocolError: "Поддерживаются только ссылки http и https.",
            statusLoading: "Загрузка вариантов скачивания…",
            statusSlowBefore: "Панель загрузки загружается дольше, чем ожидалось. ",
            statusOpenTab: "Откройте её в новой вкладке",
            statusSlowAfter: ".",
            iframeTitle: "Варианты скачивания видео",
            noteBefore: "Если панель загрузки не загружается, ",
            noteLink: "откройте варианты в новой вкладке",
            noteAfter: "."
        }
    },
    tr: {
        form: {
            label: "Video URL'si",
            placeholder: "Video URL'sini yapıştırın",
            button: "İNDİR",
            loading: "YÜKLENİYOR…",
            hint: "Örnek: https://www.youtube.com/watch?v=...",
            noscript: "JavaScript devre dışı. Bu formu gönderdiğinizde indirme paneli yeni bir sekmede açılır."
        },
        ui: {
            emptyError: "Lütfen önce bir video URL'si yapıştırın.",
            invalidError: "Bu geçerli bir URL gibi görünmüyor.",
            protocolError: "Yalnızca http ve https bağlantıları desteklenir.",
            statusLoading: "İndirme seçenekleri yükleniyor…",
            statusSlowBefore: "İndirme paneli beklenenden uzun sürüyor. ",
            statusOpenTab: "Yeni sekmede açın",
            statusSlowAfter: ".",
            iframeTitle: "Video indirme seçenekleri",
            noteBefore: "İndirme paneli yüklenmezse, ",
            noteLink: "seçenekleri yeni bir sekmede açın",
            noteAfter: "."
        }
    },
    ar: {
        form: {
            label: "رابط الفيديو",
            placeholder: "الصق رابط الفيديو",
            button: "تنزيل",
            loading: "جارٍ التحميل…",
            hint: "مثال: https://www.youtube.com/watch?v=...",
            noscript: "JavaScript معطّل. عند إرسال هذا النموذج ستُفتح لوحة التنزيل في علامة تبويب جديدة."
        },
        ui: {
            emptyError: "الصق رابط فيديو أولًا.",
            invalidError: "لا يبدو هذا رابطًا صالحًا.",
            protocolError: "يُدعم فقط روابط http وhttps.",
            statusLoading: "جارٍ تحميل خيارات التنزيل…",
            statusSlowBefore: "تستغرق لوحة التنزيل وقتًا أطول من المتوقع. ",
            statusOpenTab: "افتحها في علامة تبويب جديدة",
            statusSlowAfter: ".",
            iframeTitle: "خيارات تنزيل الفيديو",
            noteBefore: "إذا لم تُحمَّل لوحة التنزيل، ",
            noteLink: "افتح الخيارات في علامة تبويب جديدة",
            noteAfter: "."
        }
    },
    hi: {
        form: {
            label: "वीडियो URL",
            placeholder: "वीडियो URL पेस्ट करें",
            button: "डाउनलोड",
            loading: "लोड हो रहा है…",
            hint: "उदाहरण: https://www.youtube.com/watch?v=...",
            noscript: "JavaScript बंद है। यह फ़ॉर्म सबमिट करने पर डाउनलोड पैनल नए टैब में खुलेगा।"
        },
        ui: {
            emptyError: "कृपया पहले वीडियो URL पेस्ट करें।",
            invalidError: "यह मान्य URL नहीं लगता।",
            protocolError: "केवल http और https लिंक समर्थित हैं।",
            statusLoading: "डाउनलोड विकल्प लोड हो रहे हैं…",
            statusSlowBefore: "डाउनलोड पैनल अपेक्षा से अधिक समय ले रहा है। ",
            statusOpenTab: "इसे नए टैब में खोलें",
            statusSlowAfter: ".",
            iframeTitle: "वीडियो डाउनलोड विकल्प",
            noteBefore: "यदि डाउनलोड पैनल लोड न हो, ",
            noteLink: "विकल्पों को नए टैब में खोलें",
            noteAfter: "."
        }
    },
    id: {
        form: {
            label: "URL video",
            placeholder: "Tempel URL video",
            button: "UNDUH",
            loading: "MEMUAT…",
            hint: "Contoh: https://www.youtube.com/watch?v=...",
            noscript: "JavaScript dinonaktifkan. Mengirim formulir ini akan membuka panel unduhan di tab baru."
        },
        ui: {
            emptyError: "Tempel URL video terlebih dahulu.",
            invalidError: "Itu sepertinya bukan URL yang valid.",
            protocolError: "Hanya tautan http dan https yang didukung.",
            statusLoading: "Memuat opsi unduhan…",
            statusSlowBefore: "Panel unduhan membutuhkan waktu lebih lama dari biasanya. ",
            statusOpenTab: "Buka di tab baru",
            statusSlowAfter: ".",
            iframeTitle: "Opsi unduhan video",
            noteBefore: "Jika panel unduhan tidak dimuat, ",
            noteLink: "buka opsi di tab baru",
            noteAfter: "."
        }
    },
    vi: {
        form: {
            label: "URL video",
            placeholder: "Dán URL video",
            button: "TẢI XUỐNG",
            loading: "ĐANG TẢI…",
            hint: "Ví dụ: https://www.youtube.com/watch?v=...",
            noscript: "JavaScript đã bị tắt. Gửi biểu mẫu này sẽ mở bảng tải xuống trong tab mới."
        },
        ui: {
            emptyError: "Vui lòng dán URL video trước.",
            invalidError: "Đây không giống một URL hợp lệ.",
            protocolError: "Chỉ hỗ trợ liên kết http và https.",
            statusLoading: "Đang tải các tùy chọn tải xuống…",
            statusSlowBefore: "Bảng tải xuống đang mất nhiều thời gian hơn dự kiến. ",
            statusOpenTab: "Mở trong tab mới",
            statusSlowAfter: ".",
            iframeTitle: "Tùy chọn tải video xuống",
            noteBefore: "Nếu bảng tải xuống không tải, ",
            noteLink: "mở các tùy chọn trong tab mới",
            noteAfter: "."
        }
    },
    ja: {
        form: {
            label: "動画のURL",
            placeholder: "動画のURLを貼り付け",
            button: "ダウンロード",
            loading: "読み込み中…",
            hint: "例：https://www.youtube.com/watch?v=...",
            noscript: "JavaScriptが無効です。このフォームを送信すると、ダウンロードパネルが新しいタブで開きます。"
        },
        ui: {
            emptyError: "先に動画のURLを貼り付けてください。",
            invalidError: "有効なURLではないようです。",
            protocolError: "httpとhttpsのリンクのみ対応しています。",
            statusLoading: "ダウンロードオプションを読み込み中…",
            statusSlowBefore: "ダウンロードパネルの読み込みに時間がかかっています。",
            statusOpenTab: "新しいタブで開く",
            statusSlowAfter: "。",
            iframeTitle: "動画のダウンロードオプション",
            noteBefore: "ダウンロードパネルが読み込まれない場合は、",
            noteLink: "新しいタブでオプションを開いてください",
            noteAfter: "。"
        }
    },
    ko: {
        form: {
            label: "동영상 URL",
            placeholder: "동영상 URL 붙여넣기",
            button: "다운로드",
            loading: "불러오는 중…",
            hint: "예: https://www.youtube.com/watch?v=...",
            noscript: "JavaScript가 비활성화되어 있습니다. 이 양식을 제출하면 다운로드 패널이 새 탭에서 열립니다."
        },
        ui: {
            emptyError: "먼저 동영상 URL을 붙여넣으세요.",
            invalidError: "유효한 URL이 아닌 것 같습니다.",
            protocolError: "http 및 https 링크만 지원됩니다.",
            statusLoading: "다운로드 옵션을 불러오는 중…",
            statusSlowBefore: "다운로드 패널을 불러오는 데 예상보다 오래 걸리고 있습니다. ",
            statusOpenTab: "새 탭에서 열기",
            statusSlowAfter: ".",
            iframeTitle: "동영상 다운로드 옵션",
            noteBefore: "다운로드 패널이 로드되지 않으면 ",
            noteLink: "새 탭에서 옵션을 여세요",
            noteAfter: "."
        }
    },
    "zh-CN": {
        form: {
            label: "视频网址",
            placeholder: "粘贴视频网址",
            button: "下载",
            loading: "加载中…",
            hint: "示例：https://www.youtube.com/watch?v=...",
            noscript: "JavaScript 已禁用。提交此表单将在新标签页中打开下载面板。"
        },
        ui: {
            emptyError: "请先粘贴视频网址。",
            invalidError: "这似乎不是有效的网址。",
            protocolError: "仅支持 http 和 https 链接。",
            statusLoading: "正在加载下载选项…",
            statusSlowBefore: "下载面板加载时间比预期更长。",
            statusOpenTab: "在新标签页中打开",
            statusSlowAfter: "。",
            iframeTitle: "视频下载选项",
            noteBefore: "如果下载面板无法加载，",
            noteLink: "请在新标签页中打开选项",
            noteAfter: "。"
        }
    },
    "zh-TW": {
        form: {
            label: "影片網址",
            placeholder: "貼上影片網址",
            button: "下載",
            loading: "載入中…",
            hint: "範例：https://www.youtube.com/watch?v=...",
            noscript: "JavaScript 已停用。提交此表單將在新分頁中開啟下載面板。"
        },
        ui: {
            emptyError: "請先貼上影片網址。",
            invalidError: "這似乎不是有效的網址。",
            protocolError: "僅支援 http 與 https 連結。",
            statusLoading: "正在載入下載選項…",
            statusSlowBefore: "下載面板載入時間比預期更久。",
            statusOpenTab: "在新分頁中開啟",
            statusSlowAfter: "。",
            iframeTitle: "影片下載選項",
            noteBefore: "如果下載面板無法載入，",
            noteLink: "請在新分頁中開啟選項",
            noteAfter: "。"
        }
    }
};
